module.exports = __webpack_public_path__ + "static/team6-ae93a5bb2211d1fd18c164b300a36393.jpg";